import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import { TableCell } from '@mui/material';

import { BoldText } from '@app/components/common/BoldText';

import { ColumnInterface, GenericObject, ORDER_TYPES } from '../../types';

interface ColumnCellProps {
  column: ColumnInterface;
  order: GenericObject;
  handleChangeOrder(order: GenericObject): void;
}

interface SortIconProps {
  order: string;
}

const SortIcon = ({ order }: SortIconProps) => {
  const defaultMargin = 5;
  const defaultSize = 'small';
  if (order === ORDER_TYPES.ASCENDING) {
    return <ExpandLessIcon fontSize={defaultSize} style={{ marginLeft: defaultMargin }} />;
  } else if (order === ORDER_TYPES.DESCENDING) {
    return <ExpandMoreIcon fontSize={defaultSize} style={{ marginLeft: defaultMargin }} />;
  } else {
    return <UnfoldMoreIcon fontSize={defaultSize} style={{ marginLeft: defaultMargin }} />;
  }
};

export const ColumnCell = ({ column, order, handleChangeOrder }: ColumnCellProps) => {
  const columnOrder = order[column.key];

  const handleSort = () => {
    if (!column?.sort) {
      return;
    }

    if (!columnOrder) {
      handleChangeOrder({ [column.key]: ORDER_TYPES.ASCENDING });

      column.sort(ORDER_TYPES.ASCENDING);
      return;
    }

    const newOrder = columnOrder === ORDER_TYPES.ASCENDING ? ORDER_TYPES.DESCENDING : ORDER_TYPES.ASCENDING;

    handleChangeOrder({ [column.key]: newOrder });

    column.sort(newOrder);
  };

  return (
    <TableCell
      key={column.key}
      align="left"
      style={column.sort ? { cursor: 'pointer' } : {}}
      onClick={() => column.sort && handleSort()}>
      <BoldText>
        {!column.sort ? (
          column.label
        ) : (
          <span style={{ display: 'flex', alignItems: 'center' }}>
            {column.label} <SortIcon order={columnOrder as string} />
          </span>
        )}
      </BoldText>
    </TableCell>
  );
};
